import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import RoleCards from '../components/RoleCards';
import RolesPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/RolesPanelContainer';
import RolesFilters from './RolesFilters';

const RolesPanelNarrow = ({
  canCreate,
  canRead,
  category,
  currentPage,
  fetchData,
  newRole,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  roles,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(roles, { pageSize, total }));

  return (
    <RolesPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-roles-panel-narrow">
      <div className="sticky-panel-header">
        <RolesFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <RoleCards
        canCreate={canCreate}
        category={category}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={roles}
        itemsPerRow={1}
        newRole={newRole}
        readStatus={readStatus}
        readErrors={readErrors}
      />
    </RolesPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RolesPanelNarrow);
